import { render, staticRenderFns } from "./mainResult.vue?vue&type=template&id=089e115c&scoped=true&"
import script from "./mainResult.vue?vue&type=script&lang=js&"
export * from "./mainResult.vue?vue&type=script&lang=js&"
import style0 from "./mainResult.vue?vue&type=style&index=0&id=089e115c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089e115c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
